import { render } from "./EmployeeLocationWidget.vue?vue&type=template&id=2bb3ca88&scoped=true"
import script from "./EmployeeLocationWidget.vue?vue&type=script&lang=js"
export * from "./EmployeeLocationWidget.vue?vue&type=script&lang=js"

import "./EmployeeLocationWidget.vue?vue&type=style&index=0&id=2bb3ca88&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb3ca88"]])

export default __exports__